import { supabase } from '@/lib/supabase/client'

export interface QaFeedbackRow {
  id: string
  created_at: string
  tester_name: string | null
  tester_email: string | null
  section: string
  completed: 'yes' | 'no' | 'partially' | null
  clarity_score: number | null
  ease_score: number | null
  confusion_points: string | null
  improvement_ideas: string | null
  bugs_encountered: string | null
  specific_answer: string | null
  browser: string | null
  screen_size: string | null
  session_id: string | null
  user_id: string | null
  is_test: boolean | null
}

export interface QaFeedbackListParams {
  page?: number
  pageSize?: number
  testerEmail?: string
  section?: string
  hasBugs?: boolean
}

export interface QaFeedbackListResult {
  entries: QaFeedbackRow[]
  total: number
  page: number
  pageSize: number
}

export interface QaFeedbackDetailResult {
  entry: QaFeedbackRow
}

async function invokeAdminFeedback<T>(body: Record<string, unknown>): Promise<T> {
  const { data, error } = await supabase.functions.invoke('admin-feedback', { body })
  if (error) throw new Error(String(error))
  if (data?.error) throw new Error(data.error)
  return data as T
}

export function fetchQaFeedbackList(params: QaFeedbackListParams) {
  return invokeAdminFeedback<QaFeedbackListResult>({ action: 'qa_list', ...params })
}

export function fetchQaFeedbackDetail(id: string) {
  return invokeAdminFeedback<QaFeedbackDetailResult>({ action: 'qa_detail', id })
}
